import { Component, ElementRef, Inject, Injectable, ViewChild, ViewChildren, QueryList, Renderer2 } from '@angular/core';
import { faTimes, faExpandAlt, faCompressAlt, faPrint, faQuestionCircle, faArrowCircleUp, faArrowCircleDown, faFilter } from '@fortawesome/free-solid-svg-icons';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';

import { DateAgoPipe } from '../pipes/date-ago.pipe';

import { InputText } from 'primeng/inputtext';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
//import { UIChart } from 'primeng/chart';
//import { Chart } from 'chart.js'
//import { jsPDF } from 'jspdf';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

import { formatDate } from '@angular/common';
import { HttpUrlEncodingCodec } from '@angular/common/http';
// import { Chart } from 'chart.js';
import { 
  ResponseSGPBGradingScale,
  ResponseSGPBCitizenshipCode,
  ResponseSGPBWorkHabitCode,
  ResponseSGPBOptelSkills,
  GradesComments,
  ResponseStudentProgram,
  SectionGradingPeriodResponse,
  LastPublished,
  StudentProgram,
  PostSectionGradingPeriodGradesResponse,
  bulkCommentPositions,
  studentStates,
  PDFStudentProgram,
  ResponseStatusLogDetail,
  ResponseStatusLogInfoDetail
} from '../shared/models/sgpb.model';
import StudentUtils from '../shared/utilities/student-utils';
import { forkJoin } from 'rxjs';

import { DataSourceService } from '../shared/utilities/data-source.service';

@Injectable()
@Component({
  selector: 'app-home',
  styles: [`
    :host ::ng-deep .p-datatable .p-datatable-thead > tr:first-child > th {
      position: -webkit-sticky;
      position: sticky;
      top: 0;
      z-index: 999;
    }
  `],
  templateUrl: './home.component.html',
  providers: [MessageService, DateAgoPipe, ConfirmationService]
})


export class HomeComponent {

  @ViewChild('pdfTable1', { static: false }) pdfTable1: ElementRef;
  @ViewChild('dt') dt: any;
  @ViewChild('searchInput') searchInput: InputText;
  @ViewChild('cmop', { static: false }) cmop;
  @ViewChildren('sourceTh') sourceTh: QueryList<ElementRef>;
  @ViewChildren('targetTh') targetTh: QueryList<ElementRef>;
  @ViewChildren('attendanceChart') attendanceChart: QueryList<ElementRef>;

  codec = new HttpUrlEncodingCodec;

  
  head = [['Student Name', 'Gradebook Grade', 'Gradebook Override', 'Work Habits', 'Cooperation', 'Comments']]
  studentStatuses: studentStates[] = [
    { name: 'No Pending Changes', value: 'state-clean' },
    { name: 'Pending Publish', value: 'state-pending' },
    { name: 'Successful Publish', value: 'state-success' },
    { name: 'Error', value: 'state-error' }
  ];

  gradingComparison = [
    { letter: 'A', value: 1 },
    { letter: 'B', value: 2 },
    { letter: 'C', value: 3 },
    { letter: 'D', value: 4 },
    { letter: 'F', value: 5 },
    { letter: 'I', value: 6 },
    { letter: 'M', value: 7 },
    { letter: 'N', value: 8 },
    { letter: 'P', value: 9 },
    { letter: 'NP', value: 10 },
    { letter: 'E', value: 11 },
    { letter: 'S', value: 12 },
    { letter: 'U', value: 13 },
  ]

  data = [[]]

  faTimes = faTimes;
  faExpandAlt = faExpandAlt;
  faCompressAlt = faCompressAlt;
  faPrint = faPrint;
  faQuestionCircle = faQuestionCircle;
  faArrowCircleUp = faArrowCircleUp;
  faArrowCircleDown = faArrowCircleDown;
  faFilter = faFilter;

  loading: boolean = true;
  isHistorySection: boolean = false;
  public expandedRowsHistory = {};

  commentDialog: boolean = false;

  public studentsdata: ResponseStudentProgram[];
  public studentsprogram: StudentProgram[];
  public gradingscales: ResponseSGPBGradingScale[];
  public previousgradingscales: ResponseSGPBGradingScale[];
  public citizenshipcodes: ResponseSGPBCitizenshipCode[];
  public workhabitcodes: ResponseSGPBWorkHabitCode[];
  public gradescomments: GradesComments[];
  public sectionname: string;
  public gradingperiodobj: SectionGradingPeriodResponse[];
  public histroygradingperiodobj: SectionGradingPeriodResponse[];

  public statusLogdata: ResponseStatusLogDetail[];
  public parent_StatusLogdata: ResponseStatusLogDetail[];

  public idx: number;
  public baseUri: string;
  public errorMessage: string;
  public gradeResponse: PostSectionGradingPeriodGradesResponse[];
  public httpClient: HttpClient;

  public pdfStudentData: PDFStudentProgram[];

  selectedStudents: ResponseStudentProgram[];
  selectedGradeOverride: ResponseSGPBGradingScale;
  selectedWorkHabitOverride: ResponseSGPBWorkHabitCode;
  selectedCoopOverride: ResponseSGPBCitizenshipCode;

  public expandedRows = {};
  public rows: number = 10;
  public isExpanded: boolean = false;
  public temDataLength: number = 0;
  public thWidths = [];

  public showFilterRow: boolean = false;
  public bulkCommentPositions: bulkCommentPositions[] = [
    { name: '1st Comment Position', value: 1 },
    { name: '2nd Comment Position', value: 2 },
    { name: '3rd Comment Position', value: 3 }
  ];
  public selectedComment: string;
  public selectedCommentPosition: number;
  public isPdfEnabled: boolean = false;
  public editFlag: boolean = false;
  public TotalStudentRecords: number = 0;
  public isStaffUser: boolean = true;
  public isDirty: boolean = false;
  public DirtyGP = "";
  public isPublishClicked: boolean = false;
  public isValidationFailed: boolean = false;
  public LastGradeSubmitted: string;
  public LastPublished: LastPublished[];

  public receptiveskillscodes: ResponseSGPBOptelSkills[];
  public expressiveskillscodes: ResponseSGPBOptelSkills[];
  selectedReceptiveSkillsOverride: ResponseSGPBOptelSkills;
  selectedExpressiveSkillsOverride: ResponseSGPBOptelSkills;

  // charts: Chart[] = [];
  attendanceChartData: any;
  attendanceChartOptions: any;
  allGrades: string[] = [];
  gradeCounts: {}
  gradeCountChart: any;
  gradeCountOptions: any;

  msgs1: Message[];
  msgs2: Message[];
  msgs3: Message[];
  msgs4: Message[];
  msgs5: Message[];

  legacy = false; // set to true, if you want to render the original angular bindings UI

  public isReadOnlyMode = true;
  public selectedGP = "";
  public historyselectedGP = "";
  public SelectedGPIndex: number;
  public isSecondarySection = true;
  public isFinalGP = false;
  public misisSectionId: string;
  public employeeName: string;
  public publishedDate: Date;
  public publishedBy: string;
  public previousSelectedGP = "";
  public IsOptelEnable = false;
  public isOptelApplicableSchools = false;
  public isOptelAlretMessage = false;

  sectionid: string;
  realm: string;
  realm_id: string;
  app_id: string;
  is_ssl: string;
  user_id: string;
  instructorName: string;

  public isTestMode = false;
  public isPdfGenerating: boolean = false;

  constructor(
    public http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private studentUtils: StudentUtils,
    private dataSourceService: DataSourceService  
  ) {

    this.route.queryParams.subscribe(params => {

      if (params['InternalSectionId'] != undefined && params['UserId'] != undefined) {
        this.sectionid = params['InternalSectionId'];
        this.dataSourceService.setSectionId(this.sectionid); // Set section ID in service
      }
      this.user_id = params['UserId'];
      this.instructorName = params['InstructorName'];
      
      // Check for test mode in URL
      if (params['testMode'] === 'true') {
        this.toggleTestMode(true);
      }

    });

    this.baseUri = baseUrl;
    this.httpClient = http;
    // Check for test mode first
    if (this.isTestMode) {
      // Load all reference data in correct sequence
      this.loadReferenceData().then(() => {
        // Only proceed to student data after reference data is loaded
        this.getstudentprogam(http, baseUrl);
      });
    } else {
      // Standard flow for production mode
      this.getgradingscaledata(http, baseUrl);
      this.getcitizenshipcodes(http, baseUrl);
      this.getworkhabitcodes(http, baseUrl);
      this.getgradescomments(http, baseUrl);
      this.getstudentprogam(http, baseUrl);
      this.getoptelskillscodes(http, baseUrl);
    }
  }

  // Add this method to component
  public toggleTestMode(value?: boolean): void {
    if (value !== undefined) {
      this.isTestMode = value;
    } else {
      this.isTestMode = !this.isTestMode;
    }
    this.dataSourceService.setUseLocalData(this.isTestMode);

    if (this.isTestMode) {
      this.messageService.add({
        severity: 'info',
        summary: 'Test Mode Enabled',
        detail: 'Using local JSON files instead of API endpoints'
      });
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'Test Mode Disabled',
        detail: 'Using standard API endpoints'
      });
    }

    // Refresh data if needed
    this.loadReferenceData();
  }


  async loadReferenceData(): Promise<void> {
    return new Promise((resolve) => {
      // Create an array of observables for all the reference data calls
      const referenceDataCalls = [
        this.dataSourceService.getData<ResponseSGPBGradingScale[]>(
          'gradescale/get?SectionID=' + this.sectionid, 
          this.baseUri
        ),
        this.dataSourceService.getData<ResponseSGPBCitizenshipCode[]>(
          'citizenship', 
          this.baseUri
        ),
        this.dataSourceService.getData<ResponseSGPBWorkHabitCode[]>(
          'workhabit', 
          this.baseUri
        ),
        this.dataSourceService.getData<GradesComments[]>(
          'comments', 
          this.baseUri
        ),
        this.dataSourceService.getData<ResponseSGPBOptelSkills[]>(
          'Optel', 
          this.baseUri
        )
      ];
      
      // Use forkJoin to wait for all requests to complete
      forkJoin(referenceDataCalls).subscribe({
        next: ([gradingScales, citizenshipCodes, workHabitCodes, gradeComments, optelSkills]) => {
          // Process grading scales
          this.gradingscales = gradingScales as ResponseSGPBGradingScale[];
          for (let gs of this.gradingscales) {
            gs.gradingScaleID = gs.gradingScaleID.toString();
          }
          
          // Process citizenship codes
          this.citizenshipcodes = citizenshipCodes as ResponseSGPBCitizenshipCode[];
          
          // Process work habit codes
          this.workhabitcodes = workHabitCodes as ResponseSGPBWorkHabitCode[];
          for (let wh of this.workhabitcodes) {
            wh.workHabitTypeID = wh.workHabitTypeID.toString();
          }
          
          // Process grades comments
          this.gradescomments = gradeComments as GradesComments[];
          for (let comment of this.gradescomments) {
            comment.label = comment.comment_code + " " + comment.comment;
            comment.comment_code = comment.comment_code.toString();
          }
          
          // Process optel skills codes
          this.receptiveskillscodes = optelSkills as ResponseSGPBOptelSkills[];
          this.expressiveskillscodes = optelSkills as ResponseSGPBOptelSkills[];
          
          // All data is now loaded and processed
          this.previousgradingscales = this.gradingscales;
          resolve();
        },
        error: (error) => {
          this.errorService(error);
          resolve(); // Resolve anyway to prevent blocking
        }
      });
    });
  }

  onNavigateHelp() {
    window.open("https://achieve.lausd.net/plssupport", "_blank");
  }

  /**
 * Orders the student program arrays by schoolTermGradingPeriodId
 * to ensure proper index alignment throughout the application
 * @param studentsData Array of student data to be sorted
 * @returns The same array with sorted internal arrays
 */
  orderStudentProgramArrays(studentsData: ResponseStudentProgram[]): ResponseStudentProgram[] {
    if (!studentsData || studentsData.length === 0) return studentsData;

    for (let student of studentsData) {
      // Sort the main student program array
      if (student.objStudentProgram && student.objStudentProgram.length > 0) {
        student.objStudentProgram.sort((a, b) => {
          const aId = parseInt(a.schoolTermGradingPeriodID);
          const bId = parseInt(b.schoolTermGradingPeriodID);
          return aId - bId;
        });
      }

      // Sort the past student program array
      if (student.objPastStudentProgram && student.objPastStudentProgram.length > 0) {
        student.objPastStudentProgram.sort((a, b) => {
          const aId = parseInt(a.schoolTermGradingPeriodID);
          const bId = parseInt(b.schoolTermGradingPeriodID);
          return aId - bId;
        });
      }

      // Sort the grading period array inside objGradingPeriods
      if (student.objGradingPeriods &&
        student.objGradingPeriods.grading_period &&
        student.objGradingPeriods.grading_period.length > 0) {
        student.objGradingPeriods.grading_period.sort((a, b) => {
          const aId = parseInt(a.schoolTermGradingPeriodId);
          const bId = parseInt(b.schoolTermGradingPeriodId);
          return aId - bId;
        });
      }
    }

    return studentsData;
  }

  getstudentprogam(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    let employeeId = ''; this.employeeName = ''; this.publishedDate = null; this.msgs1 = []; this.msgs2 = []; this.msgs3 = []; this.msgs4 = [];

    // const getURL = baseUrl + 'studentgrade/get?SectionId=' + this.sectionid + '&StaffId=' + this.user_id
    const endpoint = 'studentgrade/get?SectionId=' + this.sectionid + '&StaffId=' + this.user_id;
    this.dataSourceService.getData<ResponseStudentProgram[]>(endpoint, baseUrl)
      .subscribe(result => {
      if (result != null && result.length > 0) {
        if (result[0].school_uid != '0') {

          // Apply the sorting utility
          this.studentsdata = this.studentUtils.orderStudentProgramArrays(result);

          if (result[0].objGradingPeriods.grading_period.filter(gp => gp.stGradingPeriodName == '1')[0].elementaryFlag == 1)
            this.isSecondarySection = false;
          else
            this.isSecondarySection = true;
          // Start pilot user implementation
          this.isOptelApplicableSchools = result[0].isOptelApplicableSchools;
          // End
          const optelGp = result[0].objGradingPeriods.grading_period.filter(gp => gp.isOptelEnable == true);
          if (optelGp.length > 0 && optelGp[0].isOptelEnable == true)
            this.IsOptelEnable = true;
          else
            this.IsOptelEnable = false;

          if (this.isSecondarySection) {

            if (result[0].objStudentProgram != null && result[0].objStudentProgram.length > 0) { 

              if (result[0].objStudentProgram[0].name.charAt(1) != 'E') {
                if (!(result[0].objStudentProgram[0].attemptedCredit <= 0 && result[0].objStudentProgram[0].sectionID.toString().length < 8)) {

                  this.studentsdata = result;                 
                  if (result.length > 0) {
                    this.employeeName = result[0].objStudentProgram[0].employeeName;
                    this.LastPublished = result[0].objLastPublished;
                    if (result[0].publishedDate != null) {
                      this.publishedDate = result[0].publishedDate;
                      this.publishedBy = result[0].publishedBy;
                    }
                    this.gradingperiodobj = result[0].objGradingPeriods.grading_period;

                    if (this.gradingperiodobj.filter(gp => gp.gradingPeriodState == 'Active').length > 0) {
                      if (this.publishedDate < this.gradingperiodobj.filter(gp => gp.gradingPeriodState == 'Active')[0].gradeEntryStartDate) {
                        this.publishedDate = null;
                      }
                    }

                    for (let item of result[0].objGradingPeriods.grading_period) {
                      this.sectionname = item.displayName;
                    }

                    // For All Grading Periods selection -- dummy value 0000
                    let allGP = {
                      sectionId: 0, schoolTermGradingPeriodId: '0000', stGradingPeriodName: 'All Grading Periods', displayName: 'All Grading Periods',
                      gradingPeriod: 'All Grading Periods', gradingPeriodState: 'Active', GradingPeriodMode: 'Active', gradeEntryStartDate: new Date(),
                      gradeEntryEndDate: new Date(), elementaryFlag: 0, isOptelEnable: false
                    }

                    this.histroygradingperiodobj = [];
                    for (let gp of this.gradingperiodobj) {
                      this.histroygradingperiodobj.push(gp);
                    }
                    this.histroygradingperiodobj.push(allGP);

                    // this.historyselectedGP = this.histroygradingperiodobj.filter(gp => gp.gradingPeriod == 'All Grading Periods')[0].schoolTermGradingPeriodId;

                    var isCurrentGP = false;
                    this.selectedGP = result[0].objGradingPeriods.grading_period.filter(gp => gp.stGradingPeriodName == '1')[0].schoolTermGradingPeriodId;
                    this.historyselectedGP = result[0].objGradingPeriods.grading_period.filter(gp => gp.stGradingPeriodName == '1')[0].schoolTermGradingPeriodId;


                    if (this.gradingperiodobj.filter(gp => gp.gradingPeriodState == 'Active').length > 0) {
                      this.selectedGP = this.gradingperiodobj.filter(gp => gp.gradingPeriodState == 'Active')[0].schoolTermGradingPeriodId;
                      this.historyselectedGP = this.gradingperiodobj.filter(gp => gp.gradingPeriodState == 'Active')[0].schoolTermGradingPeriodId;
                      this.isReadOnlyMode = false;
                      isCurrentGP = true;
                      if (this.gradingperiodobj.filter(gp => gp.gradingPeriodState == 'Active')[0].gradingPeriod.startsWith("Final")) {
                        this.isFinalGP = true;
                      }
                    }
                    this.SelectedGPIndex = this.gradingperiodobj.findIndex(gp => gp.schoolTermGradingPeriodId == this.selectedGP);

                    if (result[0].objGradingPeriods.grading_period.filter(gp => gp.schoolTermGradingPeriodId == this.selectedGP)[0].isOptelEnable == true)
                      this.IsOptelEnable = true;
                    else
                      this.IsOptelEnable = false;

                    // Added to maintain previous Selected GP
                    this.previousSelectedGP = this.selectedGP;

                    this.publishedBy = this.LastPublished.filter(x => x.schoolTermGradingPeriodID == this.selectedGP)[0].publishedBy;
                    this.publishedDate = this.LastPublished.filter(x => x.schoolTermGradingPeriodID == this.selectedGP)[0].publishedDate;
                    if (this.publishedBy.length > 1) {
                      // Added to check whether the last grade submitted using SGPB1.0 or SGPB2.0 or MiSiS
                      if (this.publishedBy.includes("LAUSD")) this.LastGradeSubmitted = "MGP 1.0";
                      else if (this.publishedBy.includes("SGPB2.0")) this.LastGradeSubmitted = "MGP 2.0";
                      else
                        this.LastGradeSubmitted = "MiSiS";
                    }

                    // Added to retrieve the Employee Name for the grading period
                    this.employeeName = result[0].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].employeeName;

                    for (let student of result) {
                      student.index = student.objStudentProgram.length - 1;
                      student.currentState = 'state-clean';
                    }
                  }
                  else {
                    this.msgs1 = [
                      { severity: 'info', summary: 'ALERT', detail: 'There are no students under this section.' }
                    ]
                  }
                  var currentDate = new Date();


                  let pastGradingPeriods = this.studentsdata[0].objGradingPeriods.grading_period.filter(g => g.schoolTermGradingPeriodId < this.selectedGP);
                  var pastGradingPeriodIds = pastGradingPeriods.map(function (a) { return a.schoolTermGradingPeriodId.toString(); });

                  for (var _s = 0; _s < this.studentsdata.length; _s++) {

                    if (this.studentsdata[_s].objStudentProgram.filter(r => r.schoolTermGradingPeriodID == this.selectedGP).length != 0) {
                      this.studentsdata[_s].objStudentProgram = this.reOrderedStudentProgramData(this.studentsdata[_s].objStudentProgram);
                      if (this.studentsdata[_s].objStudentProgram.length < this.SelectedGPIndex) {
                        this.SelectedGPIndex = this.studentsdata[_s].objStudentProgram.length - 1;
                      }
                      else {
                        this.SelectedGPIndex = this.gradingperiodobj.findIndex(gp => gp.schoolTermGradingPeriodId == this.selectedGP);
                      }

                      if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex] !== undefined) {
                        if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].name.charAt(1) == 'A') {
                          this.allGrades.push(this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].letterGrade || "Ungraded")
                          this.studentsdata[_s].status = true;
                        }
                        else {
                          this.studentsdata[_s].status = false;
                        }
                      }
                      else {
                        this.studentsdata[_s].status = false;
                      }
                      //290451 for sorting remove the spaces between student names and make the names as upper case

                      if (this.studentsdata[_s].studentLastName != null && this.studentsdata[_s].studentLastName != "") {
                        this.studentsdata[_s].studentLastName = this.studentsdata[_s].studentLastName.toUpperCase();
                      }
                      if (this.studentsdata[_s].studentFirstName != null && this.studentsdata[_s].studentFirstName != "") {
                        this.studentsdata[_s].studentFirstName = this.studentsdata[_s].studentFirstName.toUpperCase();
                      }

                      if (this.studentsdata[_s].studentMiddleName != null && this.studentsdata[_s].studentMiddleName != "") {
                        this.studentsdata[_s].studentMiddleName = this.studentsdata[_s].studentMiddleName.toUpperCase();
                      }

                      this.studentsdata[_s].studentFullName = this.studentsdata[_s].studentLastName + ", " + this.studentsdata[_s].studentFirstName + " " + this.studentsdata[_s].studentMiddleName;

                      var studentNameWithoutspace = "";
                      if (this.studentsdata[_s].studentLastName != null) {
                        studentNameWithoutspace = this.studentsdata[_s].studentLastName.replace(" ", "") + ", ";
                      }
                      if (this.studentsdata[_s].studentFirstName != null) {
                        studentNameWithoutspace = studentNameWithoutspace + this.studentsdata[_s].studentFirstName.replace(" ", "");
                      }
                      if (this.studentsdata[_s].studentMiddleName != null) {
                        studentNameWithoutspace = " " + studentNameWithoutspace + this.studentsdata[_s].studentMiddleName.replace(" ", "");
                      }


                      this.studentsdata[_s].studentFullNameWithoutSpace = studentNameWithoutspace;

                      for (var _i = 0; _i < this.studentsdata[_s].objStudentProgram.length; _i++) {

                        if (_i > 0 && pastGradingPeriodIds) {
                          this.studentsdata[_s].objStudentProgram[_i].gradingScalePrevCompare = this.compareGrades(this.studentsdata[_s].objStudentProgram[_i].letterGrade, this.studentsdata[_s].objStudentProgram[_i - 1].letterGrade);
                          this.studentsdata[_s].objStudentProgram[_i].citizenshipPrevCompare = this.compareGrades(this.studentsdata[_s].objStudentProgram[_i].citizenshipCode, this.studentsdata[_s].objStudentProgram[_i - 1].citizenshipCode);
                          this.studentsdata[_s].objStudentProgram[_i].workHabitPrevCompare = this.compareGrades(this.studentsdata[_s].objStudentProgram[_i].workHabitCode, this.studentsdata[_s].objStudentProgram[_i - 1].workHabitCode);
                        }

                        this.studentsdata[_s].objStudentProgram[_i].gradingPeriodFullName = this.gradingperiodobj.filter(book => book.stGradingPeriodName == this.studentsdata[_s].objStudentProgram[_i].name.charAt(0))[0]?.gradingPeriod;

                        this.studentsdata[_s].objStudentProgram[_i].postGradingScaleID = this.gradingscales.filter(book => book.letterGrade == this.studentsdata[_s].objStudentProgram[_i].letterGrade)[0]?.gradingScaleID || null;
                        this.studentsdata[_s].objStudentProgram[_i].postCitizenshipCode = this.citizenshipcodes.filter(book => book.citizenshipCode == this.studentsdata[_s].objStudentProgram[_i].citizenshipCode)[0]?.citizenshipCode || null;
                        this.studentsdata[_s].objStudentProgram[_i].postWorkHabitCode = this.workhabitcodes.filter(book => book.workHabitCode == this.studentsdata[_s].objStudentProgram[_i].workHabitCode)[0]?.workHabitCode || null;

                        this.studentsdata[_s].objStudentProgram[_i].postReceptiveSkills = this.receptiveskillscodes.filter(book => book.optelSkillsCode == this.studentsdata[_s].objStudentProgram[_i].receptiveSkills)[0]?.optelSkillsCode || null;
                        this.studentsdata[_s].objStudentProgram[_i].postExpressiveSkills = this.expressiveskillscodes.filter(book => book.optelSkillsCode == this.studentsdata[_s].objStudentProgram[_i].expressiveSkills)[0]?.optelSkillsCode || null;

                        this.studentsdata[_s].objStudentProgram[_i].postComment1 = this.gradescomments.filter(book => book.comment_code == this.studentsdata[_s].objStudentProgram[_i].comment1)[0]?.comment_code || null;
                        this.studentsdata[_s].objStudentProgram[_i].postComment2 = this.gradescomments.filter(book => book.comment_code == this.studentsdata[_s].objStudentProgram[_i].comment2)[0]?.comment_code || null;
                        this.studentsdata[_s].objStudentProgram[_i].postComment3 = this.gradescomments.filter(book => book.comment_code == this.studentsdata[_s].objStudentProgram[_i].comment3)[0]?.comment_code || null;

                        this.studentsdata[_s].objStudentProgram[_i].comment1Tooltip = this.gradescomments.filter(book => book.comment_code == this.studentsdata[_s].objStudentProgram[_i].comment1)[0]?.comment || null;
                        this.studentsdata[_s].objStudentProgram[_i].comment2Tooltip = this.gradescomments.filter(book => book.comment_code == this.studentsdata[_s].objStudentProgram[_i].comment2)[0]?.comment || null;
                        this.studentsdata[_s].objStudentProgram[_i].comment3Tooltip = this.gradescomments.filter(book => book.comment_code == this.studentsdata[_s].objStudentProgram[_i].comment3)[0]?.comment || null;

                        //Reset values for validation
                        this.studentsdata[_s].objStudentProgram[_i].isCommentRequired = false;
                        this.studentsdata[_s].objStudentProgram[_i].isValidationFailed = false;
                        this.studentsdata[_s].objStudentProgram[_i].ValidationMessage = '';
                        this.isValidationFailed = false;

                        this.misisSectionId = this.studentsdata[_s].objStudentProgram[_i].sectionID;
                        employeeId = this.studentsdata[_s].objStudentProgram[_i].employeeID;

                        if (isCurrentGP) {
                          this.idx = this.studentsdata[_s].objGradingPeriods.grading_period.findIndex(gp => gp.schoolTermGradingPeriodId == this.selectedGP);
                        }
                      }
                      if (result[0].objStudentProgram.filter(r => r.schoolTermGradingPeriodID == this.selectedGP).length > 0) {
                        if (this.publishedDate != null) {
                          if (this.LastGradeSubmitted.length > 1) {
                            this.msgs2 = [
                              { severity: 'info', summary: 'ALERT', detail: 'Last Published: ' + new Date(this.publishedDate).toLocaleString() + ' by ' + this.employeeName + ' from ' + this.LastGradeSubmitted }
                            ]
                          }
                          else {
                            this.msgs2 = [
                              { severity: 'info', summary: 'ALERT', detail: 'Last Published: ' + new Date(this.publishedDate).toLocaleString() + ' by ' + this.employeeName }
                            ]
                          }
                        }
                      }

                      if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex] != undefined) {
                        if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].status.toLowerCase().indexOf('success') >= 0) {
                          this.studentsdata[_s].previousState = 'state-success';
                          this.studentsdata[_s].currentState = 'state-success';
                          //this.studentsdata[_s].currentState = this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].isOptelApplicable == true &&
                          //  (this.studentsdata[_s].objStudentProgram[this.idx].postExpressiveSkills == null ||
                          //    this.studentsdata[_s].objStudentProgram[this.idx].postReceptiveSkills == null) ? 'state-clean' :
                          //  "state-success";
                          this.isPdfEnabled = true;
                          this.isDirty = false;
                        }
                        else if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].status.toLowerCase().indexOf('error') >= 0 || this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].status.toLowerCase().indexOf('failure') >= 0) {
                          this.studentsdata[_s].previousState = 'state-error';
                          this.studentsdata[_s].currentState = 'state-error';
                          this.isPdfEnabled = true;
                          this.isDirty = true;
                        }
                        else if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].status.toLowerCase() == 'not submitted') {
                          this.studentsdata[_s].previousState = 'state-clean';
                          this.studentsdata[_s].currentState = 'state-clean';
                          this.isPdfEnabled = true;
                          this.isDirty = false;
                        }
                        else {
                          this.studentsdata[_s].previousState = 'state-clean';
                          this.studentsdata[_s].currentState = 'state-clean';
                          this.isDirty = true;
                          this.isPdfEnabled = false;
                        }
                        if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex] != undefined) {
                          this.editFlag = this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].editFlag;
                        }

                      }
                      // Push to Prev object now all rules have been applied
                      this.studentsdata[_s].objPastStudentProgram = [];
                      for (let gp of pastGradingPeriodIds) {
                        let item = this.studentsdata[_s].objStudentProgram.filter(sp => sp.schoolTermGradingPeriodID == gp)[0];
                        if (item.name.charAt(1) != 'I') {
                          this.studentsdata[_s].objPastStudentProgram.push(item);
                        }
                      }

                      if (_s < this.studentsdata.length - 1) {
                        this.SelectedGPIndex = this.gradingperiodobj.findIndex(gp => gp.schoolTermGradingPeriodId == this.selectedGP);
                      }
                    }
                  }

                  // Added for Grade Book Grade change tracking
                  for (let student of result) {
                    const studentProgram = this.studentUtils.getStudentProgramAtIndex(student, this.SelectedGPIndex);
                    if (!studentProgram) return;

                    if (student.gradeBookDate > studentProgram.modifiedDate && student.letter_grade != studentProgram.letterGrade) {
                      student.currentState = 'state-pending';
                      studentProgram.postGradingScaleID = null;
                      this.isDirty = true;
                      this.DirtyGP = this.selectedGP;
                    }
                  }

                  if (this.isDirty && this.DirtyGP == this.selectedGP) {
                    this.msgs1 = [
                      { severity: 'info', summary: 'NOTICE', detail: 'There are still unpublished grades. Please verify and submit before leaving the page.' }
                    ]
                  }

                  // Expand rows tracking
                  this.studentsdata.length < this.rows ? this.temDataLength = this.studentsdata.length : this.temDataLength = this.rows;
                  this.initGradeChart();
                  this.previousgradingscales = this.gradingscales;
                  if (this.isFinalGP) {
                    this.gradingscales = this.gradingscales.filter(c => c.letterGrade != 'M');
                  }
                  if (Number(this.misisSectionId) % 2 != 0) {
                    this.gradingscales = this.gradingscales.filter(c => c.letterGrade != 'P' && c.letterGrade != 'NP');
                  }

                  if (this.gradingperiodobj.filter(gp => gp.gradingPeriodState == 'Active').length > 0) {
                    var startDate = new Date(this.gradingperiodobj.filter(gp => gp.gradingPeriodState == 'Active')[0].gradeEntryStartDate);
                    var endDate = new Date(this.gradingperiodobj.filter(gp => gp.gradingPeriodState == 'Active')[0].gradeEntryEndDate);

                    if (startDate > currentDate) {
                      if (this.msgs1.length == 0) {
                        this.msgs1 = [
                          { severity: 'info', summary: 'NOTICE', detail: 'This MiSiS Grading Period is not yet open for publishing grades. It will open on ' + formatDate(startDate, 'MM/dd/yyyy', 'en-US') }
                        ]
                      }
                      else {
                        this.msgs2 = [
                          { severity: 'info', summary: 'NOTICE', detail: 'This MiSiS Grading Period is not yet open for publishing grades. It will open on ' + formatDate(startDate, 'MM/dd/yyyy', 'en-US') }
                        ]
                      }
                    }

                    if (currentDate >= startDate && currentDate <= endDate) {
                      this.msgs4 = [
                        {
                          severity: 'info', summary: 'ALERT', detail: 'Please note that grades submitted through MGP 2.0 will override the last submitted grades from the MiSiS Manage Grade by Class grade entry screen.'
                        }
                      ]
                    }
                  }

                  if (employeeId != this.user_id) {
                    if (this.msgs1.length == 0) {
                      this.msgs1 = [
                        { severity: 'info', summary: 'ALERT', detail: 'You are viewing this screen in read-only mode. Only the Misis teacher of record can submit grades.' }
                      ]
                    }
                    else {
                      if (this.msgs2.length == 0) {
                        this.msgs2 = [
                          { severity: 'info', summary: 'ALERT', detail: 'You are viewing this screen in read-only mode. Only the Misis teacher of record can submit grades.' }
                        ]
                      }
                      else {
                        this.msgs3 = [
                          { severity: 'info', summary: 'ALERT', detail: 'You are viewing this screen in read-only mode. Only the Misis teacher of record can submit grades.' }
                        ]
                      }
                    }
                    this.isStaffUser = false;
                  }
                }
                else {
                  if (result[0].objStudentProgram[0].attemptedCredit <= 0 && result[0].objStudentProgram[0].sectionID.toString().length < 8) {
                    this.msgs5 = [
                      { severity: 'info', summary: 'ALERT', detail: 'This section has zero credits in MiSiS, hence no grades can be submitted. If you feel this message is an error, please contact your  school\'s  scheduling administrator' }
                    ]
                  }
                }
              } 
              else {
                if (result[0].objStudentProgram[0].attemptedCredit <= 0 && result[0].objStudentProgram[0].sectionID.toString().length < 8) {
                  this.msgs5 = [
                    { severity: 'info', summary: 'ALERT', detail: 'This section has zero credits in MiSiS, hence no grades can be submitted. If you feel this message is an error, please contact your  school\'s  scheduling administrator' }
                  ]
                }
                if (result[0].objStudentProgram[0].name.charAt(1) == 'E') { 
                  this.msgs1 = [
                    { severity: 'info', summary: 'ALERT', detail: 'This section is set to "Exclude Grades" in MiSiS. If you feel this message is an error, please contact your school\'s scheduling administrator.' }
                  ]
                }

              }
            }
            else {
              //To Populate the GP Drop Down
              this.gradingperiodobj = result[0].objGradingPeriods.grading_period;
              if (this.gradingperiodobj.filter(gp => gp.gradingPeriodState == 'Active').length > 0)
                this.selectedGP = result[0].objGradingPeriods.grading_period.filter(gp => gp.gradingPeriodState == 'Active')[0].schoolTermGradingPeriodId;
              if (this.selectedGP == "" && this.selectedGP.length == 0) {
                this.selectedGP = result[0].objGradingPeriods.grading_period.filter(gp => gp.stGradingPeriodName == '1')[0].schoolTermGradingPeriodId;
              }
              this.SelectedGPIndex = this.gradingperiodobj.findIndex(gp => gp.schoolTermGradingPeriodId == this.selectedGP);

              var currentDate = new Date(); currentDate.setHours(0, 0, 0, 0);

              this.msgs1 = [
                { severity: 'info', summary: 'ALERT', detail: 'There are no students under this section.' }
              ]

              if (this.gradingperiodobj.filter(gp => gp.schoolTermGradingPeriodId == this.selectedGP).length > 0) {
                var startDate = new Date(this.gradingperiodobj.filter(gp => gp.schoolTermGradingPeriodId == this.selectedGP)[0].gradeEntryStartDate);

                if (startDate > currentDate) {
                  this.msgs2 = [
                    { severity: 'info', summary: 'NOTICE', detail: 'This MiSiS Grading Period is not yet open for publishing grades. It will open on ' + formatDate(startDate, 'MM/dd/yyyy', 'en-US') }
                  ]
                }

              }
              this.isPdfEnabled = false;
            }
          }
          else {
            this.msgs1 = [
              {
                severity: 'info', summary: 'ALERT', detail: 'This is for secondary schools only. Elementary teachers, please use the Elementary Grade Pass Back app'
              }
            ]
          }
        }
        else {
          this.msgs1 = [
            { severity: 'info', summary: 'ALERT', detail: 'Grades cannot be submitted through sections that are not MiSiS scheduled. For assistance, contact the ITD Help Desk' }
          ]
        }
      }
      else {
        this.isPdfEnabled = false;
        this.msgs1 = [
          { severity: 'info', summary: 'ALERT', detail: 'There are no students under this section.' }
        ]
        if (this.msgs4.length != 0) this.msgs4 = [];
        this.isReadOnlyMode = true;
      }
      this.loading = false;
      this.TotalStudentRecords = this.studentsdata.filter(r => r.status == true).length;

      if (this.studentsdata[0].status) {
        if (this.TotalStudentRecords == 0) {
          this.isPdfEnabled = false;
          this.msgs1 = [
            { severity: 'info', summary: 'ALERT', detail: 'There are no students under this section.' }
          ]

          if (this.msgs4.length != 0) this.msgs4 = [];
          this.isReadOnlyMode = true;
        }
      }

    }, error => this.errorService(error));

  }


  reOrderedStudentProgramData(studentProgramData: StudentProgram[]): StudentProgram[] {
    console.log('reOrderedStudentProgramData')
    if (!studentProgramData || studentProgramData.length === 0) return studentProgramData;

    let seen = new Set<string>();
    let reorderedList: StudentProgram[] = [];
    let duplicates: StudentProgram[] = [];


    studentProgramData.forEach(student => {
      if (!seen.has(student.gradingMilestoneID)) {
        seen.add(student.gradingMilestoneID);
        reorderedList.push(student);
      } else {
        duplicates.push(student);
      }
    });


    let combinedList: StudentProgram[] = [...reorderedList, ...duplicates];

    return combinedList;
  }
  compareGrades(curr, prev) {
    if (typeof curr == 'undefined' || typeof prev == 'undefined') return;

    let current = this.gradingComparison.filter(c => c.letter == curr)[0]?.value,
      previous = this.gradingComparison.filter(c => c.letter == prev)[0]?.value

    if (current < previous) {
      return 'pi-arrow-circle-up text-success'
    } else if (current > previous) {
      return 'pi-arrow-circle-down text-danger'
    } else {
      return 'pi-arrow-circle-right'
    }
  }

  addDefaultMessage() {
    this.msgs1 = [
      { severity: 'success', summary: 'Success', detail: 'Here is the message default' }
    ]
  }

  initGradeChart() {
    this.gradeCounts = this.allGrades.sort().reduce(function (acc, curr) {
      if (typeof acc[curr] == 'undefined') {
        acc[curr] = 1
      } else {
        acc[curr] += 1;
      }
      return acc;
    }, {});

    this.gradeCountChart = {
      labels: null,
      datasets: [{
        type: 'horizontalBar',
        label: "A",
        backgroundColor: '#6fe080',
        data: [
          Object.values(this.gradeCounts)[0] || 0
        ]
      }, {
        type: 'horizontalBar',
        label: "B",
        backgroundColor: '#d4ed5e',
        data: [
          Object.values(this.gradeCounts)[1] || 0
        ]
      }, {
        type: 'horizontalBar',
        label: "C",
        backgroundColor: '#fce43a',
        data: [
          Object.values(this.gradeCounts)[2] || 0
        ]
      }, {
        type: 'horizontalBar',
        label: "D",
        backgroundColor: '#f39a28',
        data: [
          Object.values(this.gradeCounts)[3] || 0
        ]
      }, {
        type: 'horizontalBar',
        label: "F",
        backgroundColor: '#ee4c36',
        data: [
          Object.values(this.gradeCounts)[4] || 0
        ]
      }]
    };

    this.gradeCountOptions = {
      tooltips: {
        mode: 'nearest',
        intersect: false,
        enabled: false // might need to set to false and make external legends
      },
      responsive: true,
      scales: {
        xAxes: [{
          stacked: true,
          display: false
        }],
        yAxes: [{
          stacked: true,
          display: false
        }]
      },
      legend: { display: false }
    };
  }

  getgradingscaledata(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.dataSourceService.getData<ResponseSGPBGradingScale[]>(
      'gradescale/get?SectionID=' + this.sectionid, 
      baseUrl
    ).subscribe(result => {
      this.gradingscales = result;
      for (let gs of result) {
        gs.gradingScaleID = gs.gradingScaleID.toString();
      }
    }, error => this.errorService(error));
  }
  
  getcitizenshipcodes(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.dataSourceService.getData<ResponseSGPBCitizenshipCode[]>(
      'citizenship', 
      baseUrl
    ).subscribe(result => {
      this.citizenshipcodes = result;
    }, error => this.errorService(error));
  }
  
  getworkhabitcodes(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.dataSourceService.getData<ResponseSGPBWorkHabitCode[]>(
      'workhabit', 
      baseUrl
    ).subscribe(result => {
      this.workhabitcodes = result;
      for (let wh of result) {
        wh.workHabitTypeID = wh.workHabitTypeID.toString();
      }
    }, error => this.errorService(error));
  }
  
  getgradescomments(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.dataSourceService.getData<GradesComments[]>(
      'comments', 
      baseUrl
    ).subscribe(result => {
      this.gradescomments = result;
      for (let comment of result) {
        comment.label = comment.comment_code + " " + comment.comment;
        comment.comment_code = comment.comment_code.toString();
      }
    }, error => this.errorService(error));
  }
  

  getoptelskillscodes(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.dataSourceService.getData<ResponseSGPBOptelSkills[]>(
      'Optel', 
      baseUrl
    ).subscribe(result => {
      this.receptiveskillscodes = result;
      this.expressiveskillscodes = result;
      for (let wh of result) {
        wh.optelSkillsCode = wh.optelSkillsCode;
      }
    }, error => this.errorService(error));
  }

  expandFilterRow() {
    if (!this.showFilterRow) {
      console.log("HIDE")
      // To Do Reset filters, so active filters aren't hidden
    }
    this.showFilterRow = !this.showFilterRow
  }

  expandAll() {
    console.log("Expand All Student Rows")
    if (!this.isExpanded) {
      this.studentsdata.filter(s => s.status == true).forEach(data => {
        this.expandedRows[data.school_uid] = true;
      })
    } else {
      this.expandedRows = {};
    }
    this.isExpanded = !this.isExpanded;
    this.resizeChildColumns();
  }

  collapseAll() {
    console.log("Collapse All Student Rows")
  }

  onRowExpand(data) {
    console.log("row expanded", Object.keys(this.expandedRows).length)
    //this.charts = this.attendanceChart.map((chart, index) => {
    // Doesn't work, but could be a good starting point. 
    //  const config = Object.assign({}, this.attendanceChartOptions, { data: this.attendanceChartData[index] })
    //  return new Chart(chart.nativeElement, config)
    //})
    this.resizeChildColumns();

    if (Object.keys(this.expandedRows).length === this.temDataLength) {
      this.isExpanded = true;
    }
  }

  onRowCollapse() {
    console.log("row collapsed", Object.keys(this.expandedRows).length)
    if (Object.keys(this.expandedRows).length === 0) {
      this.isExpanded = false;
    }
  }

  resizeChildColumns() {
    this.thWidths = this.sourceTh.map(th => th.nativeElement.offsetWidth);
  }

  // Add this method to your component class
  filterTable(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.dt.filterGlobal(value, 'contains');
  }

  clearGlobalSearch() {
    const event = new KeyboardEvent('input', {
      bubbles: true, cancelable: true
    })
    this.searchInput['nativeElement'].value = '';
    this.searchInput['nativeElement'].dispatchEvent(event);
  }

  OnChangeGradingPeriod(event) {
    if (this.DirtyGP.toString().length > 1) {
      if (confirm('Please note there are still unpublished grades. Please verify and submit before leaving the page. These grades will not be available if you leave the page. Do you wish to proceed ?')) {
        this.DirtyGP = "";
        this.OnGPChange();
      }
      else {
        this.selectedGP = this.previousSelectedGP;
        event.target.value = this.selectedGP;
      }
    }
    else
      this.OnGPChange();
  }

  OnGPChange() {
    this.msgs1 = []; this.msgs2 = []; this.msgs3 = []; this.msgs4 = []; this.isExpanded = false; this.isValidationFailed = false;
    let employeeId = '';
    this.selectedWorkHabitOverride = null;
    this.selectedReceptiveSkillsOverride = null;
    this.selectedExpressiveSkillsOverride = null;
    this.selectedGradeOverride = null;
    this.selectedCoopOverride = null;
    if (this.studentsdata != null && this.studentsdata[0].objStudentProgram != null) {
      // Added to retrieve the Employee Name for the grading period
      this.employeeName = this.studentsdata[0].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].employeeName;
      employeeId = this.studentsdata[0].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].employeeID;
    }


    // Added for Final GP grading scale check
    if (this.gradingperiodobj.filter(gp => gp.schoolTermGradingPeriodId == this.selectedGP)[0].gradingPeriod.startsWith("Final")) {
      this.isFinalGP = true;
      if (this.gradingscales != null && this.gradingscales.length > 0)
        this.gradingscales = this.gradingscales.filter(c => c.letterGrade != 'M');
    }
    else {
      this.isFinalGP = false;
      this.gradingscales = this.previousgradingscales;
    }

    if (this.gradingperiodobj.filter(gp => gp.schoolTermGradingPeriodId == this.selectedGP)[0].isOptelEnable == true)
      this.IsOptelEnable = true;
    else
      this.IsOptelEnable = false;

    // Added to remove P and NP grades for Enrichment Sections
    if (Number(this.misisSectionId) % 2 != 0) {
      if (this.gradingscales != null && this.gradingscales.length > 0)
        this.gradingscales = this.gradingscales.filter(c => c.letterGrade != 'P' && c.letterGrade != 'NP');
    }

    if (this.LastPublished != null && this.LastPublished.length > 0) {
      this.publishedBy = this.LastPublished.filter(x => x.schoolTermGradingPeriodID == this.selectedGP)[0].publishedBy;
      this.publishedDate = this.LastPublished.filter(x => x.schoolTermGradingPeriodID == this.selectedGP)[0].publishedDate;

      if (this.publishedBy.length > 1) {
        // Added to check whether the last grade submitted using SGPB1.0 or SGPB2.0 or MiSiS
        if (this.publishedBy.includes("LAUSD")) this.LastGradeSubmitted = "MGP 1.0";
        else if (this.publishedBy.includes("SGPB2.0")) this.LastGradeSubmitted = "MGP 2.0";
        else
          this.LastGradeSubmitted = "MiSiS";
      }
    }
    // Added for maintaining the previous Selected GP
    this.previousSelectedGP = this.selectedGP;

    if (this.studentsdata != null && this.studentsdata.length > 0) {
      // Added for Expand/Collapse All
      let pastGradingPeriods = this.studentsdata[0].objGradingPeriods.grading_period.filter(g => g.schoolTermGradingPeriodId < this.selectedGP);
      var pastGradingPeriodIds = pastGradingPeriods.map(function (a) { return a.schoolTermGradingPeriodId.toString(); });

      for (var _s = 0; _s < this.studentsdata.length; _s++) {
        // Push to Prev object now all rules have been applied
        this.studentsdata[_s].objPastStudentProgram = [];
        for (let gp of pastGradingPeriodIds) {
          let item = this.studentsdata[_s].objStudentProgram.filter(sp => sp.schoolTermGradingPeriodID == gp)[0];
          if (item.name.charAt(1) != 'I') {
            this.studentsdata[_s].objPastStudentProgram.push(item);
          }
        }

        // Added to clear the pending changes
        if (this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].gradingScaleID != "")
          this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].postGradingScaleID = this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].gradingScaleID;
        if (this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].workHabitCode != "")
          this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].postWorkHabitCode = this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].workHabitCode;
        if (this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].citizenshipCode != "")
          this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].postCitizenshipCode = this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].citizenshipCode;
        //if (this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].comment1 == null || this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].comment1 == "")
        this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].postComment1 = this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].comment1;
        //if (this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].comment2 == null || this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].comment2 == "")
        this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].postComment2 = this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].comment2;
        //if (this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].comment3 == null || this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].comment3 == "")
        this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].postComment3 = this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].comment3;
        if (this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].receptiveSkills != "")
          this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].postReceptiveSkills = this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].receptiveSkills;
        if (this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].expressiveSkills != "")
          this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].postExpressiveSkills = this.studentsdata[_s].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].expressiveSkills;

        // Added to update the Chart
        for (var _i = 0; _i < this.studentsdata[_s].objStudentProgram.length; _i++) {

          if (_i > 0 && pastGradingPeriodIds) {
            this.studentsdata[_s].objStudentProgram[_i].gradingScalePrevCompare = this.compareGrades(this.studentsdata[_s].objStudentProgram[_i].letterGrade, this.studentsdata[_s].objStudentProgram[_i - 1].letterGrade);
            this.studentsdata[_s].objStudentProgram[_i].citizenshipPrevCompare = this.compareGrades(this.studentsdata[_s].objStudentProgram[_i].citizenshipCode, this.studentsdata[_s].objStudentProgram[_i - 1].citizenshipCode);
            this.studentsdata[_s].objStudentProgram[_i].workHabitPrevCompare = this.compareGrades(this.studentsdata[_s].objStudentProgram[_i].workHabitCode, this.studentsdata[_s].objStudentProgram[_i - 1].workHabitCode);
          }
        }
      }
    }

    var todaysDate = new Date(); todaysDate.setHours(0, 0, 0, 0);
    var gpData = this.gradingperiodobj.filter(gp => gp.schoolTermGradingPeriodId == this.selectedGP)[0];
    var gp = gpData.gradingPeriodState;
    if (gp == "Active") {
      this.isReadOnlyMode = false;
      if (employeeId != this.user_id) {
        this.msgs3 = [
          { severity: 'info', summary: 'ALERT', detail: 'You are viewing this screen in read-only mode. Only the Misis teacher of record can submit grades.' }
        ]
        this.isStaffUser = false; this.isPdfEnabled = false;
      }

      if (this.studentsdata != null) {
        if (this.studentsdata[0].objStudentProgram.filter(r => r.schoolTermGradingPeriodID == this.selectedGP).length > 0) {
          if (this.publishedDate != null) {
            if (this.LastGradeSubmitted.length > 1) {
              this.msgs2 = [
                { severity: 'info', summary: 'ALERT', detail: 'Last Published: ' + new Date(this.publishedDate).toLocaleString() + ' by ' + this.employeeName + ' from ' + this.LastGradeSubmitted }
              ]
            }
            else {
              this.msgs2 = [
                { severity: 'info', summary: 'ALERT', detail: 'Last Published: ' + new Date(this.publishedDate).toLocaleString() + ' by ' + this.employeeName }
              ]
            }
          }

          var endDate = new Date(gpData.gradeEntryEndDate);
          var startDate = new Date(gpData.gradeEntryStartDate);

          if (todaysDate >= startDate && todaysDate <= endDate) {
            this.msgs4 = [
              {
                severity: 'info', summary: 'ALERT', detail: 'Please note that grades submitted through MGP 2.0 will override the last submitted grades from the MiSiS Manage Grade by Class grade entry screen.'
              }
            ]
          }

        }
      }
      else {
        this.isPdfEnabled = false;
        var startDate = new Date(gpData.gradeEntryStartDate);
        if (startDate > todaysDate) {
          this.msgs2 = [
            { severity: 'info', summary: 'NOTICE', detail: 'This MiSiS Grading Period is not yet open for publishing grades. It will open on ' + formatDate(startDate, 'MM/dd/yyyy', 'en-US') }
          ]
        }
      }
    }
    else {
      var endDate = new Date(gpData.gradeEntryEndDate);
      var startDate = new Date(gpData.gradeEntryStartDate);

      if (todaysDate >= startDate && todaysDate <= endDate) {
        this.isReadOnlyMode = false;
        this.isPdfEnabled = true;
        this.isDirty = false;
        this.msgs4 = [
          {
            severity: 'info', summary: 'ALERT', detail: 'Please note that grades submitted through MGP 2.0 will override the last submitted grades from the MiSiS Manage Grade by Class grade entry screen.'
          }
        ]
      }
      else {
        this.isReadOnlyMode = true;
        this.isPdfEnabled = false;
        this.msgs4 = [];
      }

      if (endDate < todaysDate) {
        this.msgs2 = [
          { severity: 'info', summary: 'NOTICE', detail: 'MiSiS Grade submission for this grading period is currently closed.' }
        ]
      }
      else if (startDate > todaysDate) {
        this.msgs2 = [
          { severity: 'info', summary: 'NOTICE', detail: 'This MiSiS Grading Period is not yet open for publishing grades. It will open on ' + formatDate(startDate, 'MM/dd/yyyy', 'en-US') }
        ]
      }
    }

    if (this.studentsdata != null) {
      if (this.publishedDate != null) {
        if (this.LastGradeSubmitted.length > 1) {
          this.msgs2 = [
            { severity: 'info', summary: 'ALERT', detail: 'Last Published: ' + new Date(this.publishedDate).toLocaleString() + ' by ' + this.employeeName + ' from ' + this.LastGradeSubmitted }
          ]
        }
        else {
          this.msgs2 = [
            { severity: 'info', summary: 'ALERT', detail: 'Last Published: ' + new Date(this.publishedDate).toLocaleString() + ' by ' + this.employeeName }
          ]
        }
      }
      for (var _s = 0; _s < this.studentsdata.length; _s++) {
        if (this.studentsdata[_s].objStudentProgram.filter(r => r.schoolTermGradingPeriodID == this.selectedGP).length != 0) {
          this.SelectedGPIndex = this.gradingperiodobj.findIndex(gp => gp.schoolTermGradingPeriodId == this.selectedGP);
          //Added to hide the not enrolled students in the respective gps
          if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].name.charAt(1) == 'I') {
            //this.studentsdata.splice(_s, 1);          
            this.studentsdata[_s].status = false;
          }
          else {
            this.studentsdata[_s].status = true;
          }
        }
        if (this.studentsdata[_s].objStudentProgram[0].attemptedCredit <= 0 && this.studentsdata[_s].objStudentProgram[0].sectionID.toString().length < 8) {

          this.msgs5 = [
            { severity: 'info', summary: 'ALERT', detail: 'This section has zero credits in MiSiS, hence no grades can be submitted. If you feel this message is an error, please contact your  school\'s  scheduling administrator' }
          ]
        }
      }

      if (this.studentsdata.filter(r => r.status == true).length == 0) {
        if (this.msgs1.length == 0) {
          this.msgs1 = [
            { severity: 'info', summary: 'ALERT', detail: 'There are no students under this section.' }
          ]
        }
        else {
          this.msgs2 = [
            { severity: 'info', summary: 'ALERT', detail: 'There are no students under this section.' }
          ]
        }

        if (this.msgs4.length != 0) {
          this.msgs4 = [];
        }
        this.isReadOnlyMode = true;
        this.isPdfEnabled = false;
      }

      this.historyselectedGP = this.selectedGP;

      // reset some state
      this.expandedRows = {}
      this.getGradesCount();

      //Added to enable the publish button if one/more pending items to publish
      if (this.studentsdata.filter(sss => sss.currentState == 'state-pending').length > 0 && this.DirtyGP == gpData.schoolTermGradingPeriodId)
        this.isDirty = true;

      if (this.isDirty && this.DirtyGP == gpData.schoolTermGradingPeriodId) {

        //Added to disable the publish button if one/more pending items to publish
        if (this.studentsdata.filter(sss => sss.currentState == 'state-error').length > 0 && this.DirtyGP == gpData.schoolTermGradingPeriodId)
          this.isDirty = false;

        var postStudentData = this.studentsdata.filter(sss => sss.currentState == 'state-pending');

        if (postStudentData.length != 0) {

          this.msgs1 = [
            { severity: 'info', summary: 'NOTICE', detail: 'There are still unpublished grades. Please verify and submit before leaving the page.' }
          ]

          this.msgs4 = [
            {
              severity: 'info', summary: 'ALERT', detail: 'Please note that grades submitted through MGP 2.0 will override the last submitted grades from the MiSiS Manage Grade by Class grade entry screen.'
            }
          ]
        }
      }
      if (this.isReadOnlyMode == false) {
        for (var _s = 0; _s < this.studentsdata.length; _s++) {
          if (this.studentsdata[_s].status == true) {
            this.onChangeTracking(null, this.studentsdata[_s], 0);
          }
        }

        //Added to enable the publish button if one/more pending items to publish
        if (this.studentsdata.filter(sss => sss.currentState == 'state-pending').length > 0 && this.DirtyGP == gpData.schoolTermGradingPeriodId) {
          this.isDirty = true;

          this.msgs1 = [
            { severity: 'info', summary: 'NOTICE', detail: 'There are still unpublished grades. Please verify and submit before leaving the page.' }
          ]

        }

        //Added to disable the publish button if one/more pending items to publish
        if (this.studentsdata.filter(sss => sss.currentState == 'state-error').length > 0 && this.DirtyGP == gpData.schoolTermGradingPeriodId)
          this.isDirty = false;
        else {
          if (this.studentsdata.filter(r => r.currentState == 'state-clean').length == this.studentsdata.length) {
            this.isPdfEnabled = false;
            this.isDirty = true;

            this.msgs4 = [
              {
                severity: 'info', summary: 'ALERT', detail: 'Please note that grades submitted through MGP 2.0 will override the last submitted grades from the MiSiS Manage Grade by Class grade entry screen.'
              }
            ]
          }
        }
      }
    }
    else {
      this.msgs1 = [
        { severity: 'info', summary: 'ALERT', detail: 'There are no students under this section.' }
      ]
    }
  }

  getGradesCount() {
    this.allGrades = [];
    for (var _s = 0; _s < this.studentsdata.length; _s++) {
      if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].name.charAt(1) == 'A') {
        if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex] !== undefined) {
          this.allGrades.push(this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].letterGrade == "" ? "Ungraded" : this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].letterGrade)
          this.studentsdata[_s].status = true;

          if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].status.toLowerCase().indexOf('success') >= 0) {
            this.studentsdata[_s].previousState = 'state-success';

            if (this.studentsdata[_s].currentState != 'state-pending') {
              this.studentsdata[_s].currentState = 'state-success';
            }

            this.isPdfEnabled = true;
          }
          else if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].status.toLowerCase().indexOf('error') >= 0 || this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].status.toLowerCase().indexOf('failure') >= 0) {
            this.studentsdata[_s].previousState = 'state-error';
            this.studentsdata[_s].currentState = 'state-error';
            this.isPdfEnabled = true;
          }
          else {
            this.studentsdata[_s].previousState = 'state-clean';
            this.studentsdata[_s].currentState = 'state-clean';
            this.isPdfEnabled = false;
          }
          if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex] != undefined) {
            this.editFlag = this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].editFlag;
          }
        }
        else {
          this.studentsdata[_s].status = false;
        }
      }
      else {
        this.studentsdata[_s].status = false;
      }
    }
    this.TotalStudentRecords = this.studentsdata.filter(r => r.status == true).length;
    this.initGradeChart();
  }

  errorService(error) {
    this.messageService.add({ key: 'c', sticky: true, severity: 'error', summary: 'Error ', detail: 'Oops, Something went wrong. Please try again later.' })
  }

  onReject() {
    this.messageService.clear('c')
  }

  onConfirm() {
    window.location.reload();
  }

  // To Do - refactor this to be more reusable
  gradeOverride(event) {
    if (this.selectedStudents?.length > 0) {
      for (var _s = 0; _s < this.studentsdata.length; _s++) {
        for (var _i = 0; _i < this.selectedStudents.length; _i++) {
          if (this.studentsdata[_s].school_uid == this.selectedStudents[_i].school_uid) {
            if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex] !== undefined) {
              this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postGradingScaleID = event.value;
              this.onChangeTracking(event, this.studentsdata[_s], 0);
            }
          }
        }
      }

    } else {
      for (var _s = 0; _s < this.studentsdata.length; _s++) {
        if (this.studentsdata[_s].status == true) {
          this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postGradingScaleID = event.value;
          this.onChangeTracking(event, this.studentsdata[_s], 0);
        }
      }
    }
  }

  workHabitOverride(event) {
    if (this.selectedStudents?.length > 0) {
      for (var _s = 0; _s < this.studentsdata.length; _s++) {
        for (var _i = 0; _i < this.selectedStudents.length; _i++) {
          if (this.studentsdata[_s].school_uid == this.selectedStudents[_i].school_uid) {
            if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex] !== undefined) {
              this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postWorkHabitCode = event.value;
              this.onChangeTracking(event, this.studentsdata[_s], 0);
            }
          }
        }
      }
    } else {
      for (var _s = 0; _s < this.studentsdata.length; _s++) {
        if (this.studentsdata[_s].status == true) {
          this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postWorkHabitCode = event.value;
          this.onChangeTracking(event, this.studentsdata[_s], 0);
        }
      }
    }

  }

  ReceptiveSkillsOverride(event) {
    if (this.selectedStudents?.length > 0) {
      for (var _s = 0; _s < this.studentsdata.length; _s++) {
        for (var _i = 0; _i < this.selectedStudents.length; _i++) {
          if (this.studentsdata[_s].school_uid == this.selectedStudents[_i].school_uid) {
            if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex] !== undefined) {
              if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].isOptelApplicable) {
                this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postReceptiveSkills = event.value;
                this.onChangeTracking(event, this.studentsdata[_s], 0);
              }
            }
          }
        }
      }
    } else {
      for (var _s = 0; _s < this.studentsdata.length; _s++) {
        if (this.studentsdata[_s].status == true) {
          if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].isOptelApplicable) {
            this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postReceptiveSkills = event.value;
            this.onChangeTracking(event, this.studentsdata[_s], 0);
          }
        }
      }
    }

  }
  ExpressiveSkillsOverride(event) {
    if (this.selectedStudents?.length > 0) {
      for (var _s = 0; _s < this.studentsdata.length; _s++) {
        for (var _i = 0; _i < this.selectedStudents.length; _i++) {
          if (this.studentsdata[_s].school_uid == this.selectedStudents[_i].school_uid) {
            if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex] !== undefined) {
              if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].isOptelApplicable) {
                this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postExpressiveSkills = event.value;
                this.onChangeTracking(event, this.studentsdata[_s], 0);
              }
            }
          }
        }
      }
    } else {
      for (var _s = 0; _s < this.studentsdata.length; _s++) {
        if (this.studentsdata[_s].status == true) {
          if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].isOptelApplicable) {
            this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postExpressiveSkills = event.value;
            this.onChangeTracking(event, this.studentsdata[_s], 0);
          }
        }
      }
    }

  }
  citizenOverride(event) {
    if (this.selectedStudents?.length > 0) {
      for (var _s = 0; _s < this.studentsdata.length; _s++) {
        for (var _i = 0; _i < this.selectedStudents.length; _i++) {
          if (this.studentsdata[_s].school_uid == this.selectedStudents[_i].school_uid) {
            if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex] !== undefined) {
              this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postCitizenshipCode = event.value;
              this.onChangeTracking(event, this.studentsdata[_s], 0);
            }
          }
        }
      }
    } else {
      for (var _s = 0; _s < this.studentsdata.length; _s++) {
        if (this.studentsdata[_s].status == true) {
          this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postCitizenshipCode = event.value;
          this.onChangeTracking(event, this.studentsdata[_s], 0);
        }
      }
    }

  }

  commentOverride() {
    if (this.selectedStudents?.length > 0) {
      for (var _s = 0; _s < this.studentsdata.length; _s++) {

        for (var _i = 0; _i < this.selectedStudents.length; _i++) {
          if (this.studentsdata[_s].school_uid == this.selectedStudents[_i].school_uid) {
            if (this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex] !== undefined) {
              switch (this.selectedCommentPosition) {
                case 1: {
                  this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postComment1 = this.selectedComment.toString();
                  break;
                }
                case 2: {
                  this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postComment2 = this.selectedComment.toString();
                  break;
                }
                case 3: {
                  this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postComment3 = this.selectedComment.toString();
                  break;
                }
              }
            }
            this.onChangeTracking(event, this.studentsdata[_s], 0);
          }
        }
      }

    } else {
      for (var _s = 0; _s < this.studentsdata.length; _s++) {
        if (this.studentsdata[_s].status == true) {
          switch (this.selectedCommentPosition) {
            case 1: {
              this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postComment1 = this.selectedComment.toString();
              break;
            }
            case 2: {
              this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postComment2 = this.selectedComment.toString();
              break;
            }
            case 3: {
              this.studentsdata[_s].objStudentProgram[this.SelectedGPIndex].postComment3 = this.selectedComment.toString();
              break;
            }
          }
          this.onChangeTracking(event, this.studentsdata[_s], 0);
        }
      }
    }

    this.selectedComment = null;
    this.selectedCommentPosition = null;
    this.cmop.hide();

  }


  onChangeTracking(event, student, ctrl) {
    let watchedFields = ["gradingScaleID", "workHabitCode", "citizenshipCode", "receptiveSkills", "expressiveSkills"]
    const studentProgram = this.studentUtils.getStudentProgramAtIndex(student, this.SelectedGPIndex);
    if (!studentProgram) return;
  
    // PrimeNG's Clear function sets ngModel to null - so normalize the data so comparisons below work as expected
    for (var _w = 0; _w < watchedFields.length; _w++) {
      if (studentProgram[watchedFields[_w]] == '' || typeof studentProgram[watchedFields[_w]] === 'undefined') {
        studentProgram[watchedFields[_w]] = null;
      }
    }

    if (studentProgram.postComment1 == null || studentProgram.postComment1 == '')
      studentProgram.postComment1 = '';
    if (studentProgram.postComment2 == null || studentProgram.postComment2 == '')
      studentProgram.postComment2 = '';
    if (studentProgram.postComment3 == null || studentProgram.postComment3 == '')
      studentProgram.postComment3 = '';
    if (studentProgram.comment1 == null || studentProgram.comment1 == '')
      studentProgram.comment1 = '';
    if (studentProgram.comment2 == null || studentProgram.comment2 == '')
      studentProgram.comment2 = '';
    if (studentProgram.comment3 == null || studentProgram.comment3 == '')
      studentProgram.comment3 = '';

    if (studentProgram.postGradingScaleID != studentProgram.gradingScaleID
      || studentProgram.postWorkHabitCode != studentProgram.workHabitCode
      || studentProgram.postCitizenshipCode != studentProgram.citizenshipCode
      || studentProgram.postComment1 != studentProgram.comment1
      || studentProgram.postComment2 != studentProgram.comment2
      || studentProgram.postComment3 != studentProgram.comment3
      || studentProgram.postReceptiveSkills != studentProgram.receptiveSkills
      || studentProgram.postExpressiveSkills != studentProgram.expressiveSkills
    ) {
      student.currentState = 'state-pending';
      this.isPdfEnabled = false;
      this.isDirty = false;
    } else {
      student.currentState = student.previousState;
      this.isPdfEnabled = true;
      this.isDirty = false; this.msgs1 = []; this.DirtyGP = "";

      var postStudentData = this.studentsdata.filter(sss => sss.currentState == 'state-pending' || sss.currentState == 'state-clean' || sss.currentState == 'state-error');

      if (postStudentData.length == 0) {
        this.isDirty = false;
        this.msgs1 = [];
        this.isValidationFailed = false;
        studentProgram.isValidationFailed = false;
        studentProgram.ValidationMessage = '';
      }

    }

    if (this.isDirty == false && student.currentState == 'state-pending') {
      this.isDirty = true;
      this.DirtyGP = this.selectedGP;
      this.msgs1 = [
        { severity: 'info', summary: 'NOTICE', detail: 'There are still unpublished grades. Please verify and submit before leaving the page.' }
      ]
    }

    if (student.currentState == 'state-clean') {
      this.msgs1 = [];
      this.isValidationFailed = false;
      studentProgram.isValidationFailed = false;
      studentProgram.ValidationMessage = '';
    }

    var comment1 = studentProgram.postComment1 || '';
    var comment2 = studentProgram.postComment2 || '';
    var comment3 = studentProgram.postComment3 || '';

    // comment required validation
    //isCommentRequired
    if ((studentProgram.postWorkHabitCode == 'U' ||
      studentProgram.postCitizenshipCode == 'U') &&
      comment1 == '' && comment2 == '' && comment3 == '') {
      studentProgram.ValidationMessage = 'Comments are required when Work Habits or Cooperation is Unsatisfactory';
      studentProgram.isCommentRequired = true;
      studentProgram.isValidationFailed = true;
      this.isValidationFailed = true;
      student.currentState = 'state-error';
    } else {
      studentProgram.isCommentRequired = false;
      if (studentProgram.ValidationMessage === 'Comments are required when Work Habits or Cooperation is Unsatisfactory') {
        studentProgram.ValidationMessage = '';
        studentProgram.isValidationFailed = false;
        this.isValidationFailed = false;
      }
    }

    // Validation for Letter grade
    if (studentProgram.postGradingScaleID == '' || studentProgram.postGradingScaleID == null) {
      if (this.gradingscales.filter(r => r.letterGrade == student.letter_grade).length == 0) {
        if (student.currentState == 'state-pending') {
          studentProgram.ValidationMessage = 'You must select a valid letter grade for this student';
          studentProgram.isValidationFailed = true;
          this.isValidationFailed = true;
          student.currentState = 'state-error';
        }
      }
    }
    else {
      studentProgram.ValidationMessage = '';
      studentProgram.isValidationFailed = false;
      this.isValidationFailed = false;
    }

    // Duplicate comments validation
    if ((comment1 == comment2 && comment1 != '') || (comment1 == comment3 && comment3 != '') || (comment2 == comment3 && comment2 != '')) {
      studentProgram.isValidationFailed = true;
      studentProgram.ValidationMessage = 'You have entered a duplicate comment';
      this.isValidationFailed = true;
      student.currentState = 'state-error';
      this.isDirty = false;
    }
    else {
      if (studentProgram.ValidationMessage == 'You have entered a duplicate comment') {
        studentProgram.isValidationFailed = false;
        studentProgram.ValidationMessage = '';
      }
    }

    if (student.currentState == 'state-pending') {
      if ((student.letter_grade || 'N/A') == 'N/A' && (studentProgram.postGradingScaleID || '') == '') {
        studentProgram.isValidationFailed = true;
        studentProgram.ValidationMessage = 'You must select a valid letter grade for this student';
        this.isValidationFailed = true;
        student.currentState = 'state-error';
      }
      else if ((student.letter_grade || 'N/A') != 'N/A' && Number(student.letter_grade) > 0 && (studentProgram.postGradingScaleID || '') == '') {
        studentProgram.isValidationFailed = true;
        studentProgram.ValidationMessage = 'You must select a valid letter grade for this student';
        this.isValidationFailed = true;
        student.currentState = 'state-error';
      }
    }

    var postStudentData = this.studentsdata.filter(sss => sss.currentState == 'state-error' && sss.status == true);

    if (postStudentData.length > 0) {
      this.isDirty = false;
      this.msgs1 = [];
      this.isValidationFailed = true;
    }
    else {
      var postStudentData = this.studentsdata.filter(sss => sss.currentState == 'state-pending' && sss.status == true);

      if (postStudentData.length > 0) {
        this.isDirty = true;
        this.isValidationFailed = false;
      }
      else {
        var postStudentData = this.studentsdata.filter(sss => sss.currentState == 'state-clean' && sss.status == true);

        if (postStudentData.length > 0) {
          this.isDirty = true;
          this.isValidationFailed = false;
        }
      }
    }

  }

  ValidateLetterGrades() {
    let isValid: boolean;
    isValid = true;

    for (let student of this.studentsdata) {

      if (student.status == false) continue;
      
      const studentProgram = this.studentUtils.getStudentProgramAtIndex(student, this.SelectedGPIndex);
      if (!studentProgram) return;
    
      // Validation for Letter grade
      studentProgram.ValidationMessage = '';
      studentProgram.isValidationFailed = false;
      this.isValidationFailed = false;
      if (this.gradingscales.filter(r => r.letterGrade == student.letter_grade).length == 0 && (studentProgram.postGradingScaleID || '') == '') {
        studentProgram.isValidationFailed = true;
        studentProgram.ValidationMessage = 'You must select a valid letter grade for this student';
        isValid = false;
        this.isValidationFailed = true;
        student.currentState = 'state-error';
      }
      else {
        if ((student.letter_grade || 'N/A') == 'N/A' && (studentProgram.postGradingScaleID || '') == '') {
          studentProgram.isValidationFailed = true;
          studentProgram.ValidationMessage = 'You must select a valid letter grade for this student';
          isValid = false;
          this.isValidationFailed = true;
          student.currentState = 'state-error';
        }
        else if ((student.letter_grade || 'N/A') != 'N/A' && Number(student.letter_grade) > 0 && (studentProgram.postGradingScaleID || '') == '') {
          studentProgram.isValidationFailed = true;
          studentProgram.ValidationMessage = 'You must select a valid letter grade for this student';
          isValid = false;
          this.isValidationFailed = true;
          student.currentState = 'state-error';
        }
      }
    }
    return isValid;
  }

  PostData(selectedStudents) {
    let studentWithErr = [];
    this.isOptelAlretMessage = false;
    let isLetterGradeValid: boolean;
    isLetterGradeValid = this.ValidateLetterGrades();

    if (isLetterGradeValid == false) {
      this.isValidationFailed = true;
      this.isDirty = false;
      return;
    }

    // Added to verify the grades submitted for the selected students through MiSiS/SGPB1.0
    var publishCount = 0;
    // End For Optel Acknowledgement banner for OPTEL
    if (selectedStudents.length > 0) {
      if (selectedStudents[0].isOptelApplicableSchools && this.isFinalGP == true) {
        this.idx = selectedStudents[0].objGradingPeriods.grading_period.findIndex(gp => gp.schoolTermGradingPeriodId == this.selectedGP);
        for (let ss of selectedStudents) {
          if (ss.status) {
            if (ss.objStudentProgram[this.idx].isOptelApplicable == true && (ss.objStudentProgram[this.idx].postExpressiveSkills == null || ss.objStudentProgram[this.idx].postReceptiveSkills == null)) {
              this.isOptelAlretMessage = true;
              studentWithErr.push(ss.school_uid);
            }
          }
        }
      }
    
    // Start For Optel Acknowledgement banner for OPTEL
    var postStudentData = selectedStudents.filter(sss => sss.currentState == 'state-pending' || sss.currentState == 'state-clean');
    if (postStudentData.length > 0) {

      this.idx = postStudentData[0].objGradingPeriods.grading_period.findIndex(gp => gp.schoolTermGradingPeriodId == this.selectedGP);

      for (let ss of postStudentData) {
        if (ss.status) {
          if (ss.objStudentProgram[this.idx].modifiedBy != "SGPB2.0" && ss.objStudentProgram[this.idx].modifiedBy != "") publishCount++;

            //if (ss.objStudentProgram[this.idx].isOptelApplicable == true && (ss.objStudentProgram[this.idx].postExpressiveSkills == null || ss.objStudentProgram[this.idx].postReceptiveSkills == null)) {
            //this.isOptelAlretMessage = true;
            //studentWithErr.push(ss.school_uid);
          }
        }
      }
    }

    if (this.isOptelAlretMessage == true && this.isOptelApplicableSchools == true) {
      //if (!confirm('Please note, marks are missing for OPTEL Receptive Skills / Expressive Skills. Do you wish to proceed ?')) {
      // return;
      //}
      this.confirmationService.confirm({
        message: "Please note, marks are missing for OPTEL Receptive Skills / Expressive Skills. Do you wish to proceed ?",
        rejectLabel: 'Cancel',
        acceptLabel: 'Ok',
        acceptButtonStyleClass: 'dialogAcceptButton',
        rejectButtonStyleClass: 'dialogRejectButton',
        key: 'confDialog',
        accept: () => { this.publishData(postStudentData, publishCount, studentWithErr) },
        reject: () => { return }
      });
    }
    else {
      this.publishData(postStudentData, publishCount, studentWithErr);
    } 
  }

  publishData(postStudentData, publishCount, studentWithErr) {
    if (this.publishedBy.length > 1) {
      if (publishCount > 0) { 
        if (
          confirm(
            "Please note that grades submitted through MGP 2.0 will override the last submitted grades from the MiSiS Manage Grade by Class grade entry screen. Do you wish to proceed ?"
          )
        ) {
          this.PostDatatoDB(postStudentData, studentWithErr);
        }
      } else this.PostDatatoDB(postStudentData, studentWithErr);
    } else this.PostDatatoDB(postStudentData, studentWithErr);
  }

  PostDatatoDB(postStudentData, studentWithErr) {
    this.isDirty = false;
    this.isPublishClicked = true;
    let gradingScaleID: string;

    if (postStudentData != null) {

      let grades: StudentProgram[] = [];
      //var postStudentData = selectedStudents.filter(sss => sss.currentState == 'state-pending' || sss.currentState == 'state-clean');

      if (postStudentData.length > 0) {

        this.idx = postStudentData[0].objGradingPeriods.grading_period.findIndex(gp => gp.schoolTermGradingPeriodId == this.selectedGP);
        //let http: HttpClient;
        for (let ss of postStudentData) {
          if (ss.status) {
            ss.objStudentProgram[this.idx].comment1 = ss.objStudentProgram[this.idx].postComment1 != undefined ? ss.objStudentProgram[this.idx].postComment1.toString() : null;
            ss.objStudentProgram[this.idx].comment2 = ss.objStudentProgram[this.idx].postComment2 != undefined ? ss.objStudentProgram[this.idx].postComment2.toString() : null;
            ss.objStudentProgram[this.idx].comment3 = ss.objStudentProgram[this.idx].postComment3 != undefined ? ss.objStudentProgram[this.idx].postComment3.toString() : null;
            if (ss.objStudentProgram[this.idx].postGradingScaleID == '' || ss.objStudentProgram[this.idx].postGradingScaleID == null) {
              gradingScaleID = this.gradingscales.filter(r => r.letterGrade == ss.letter_grade)[0].gradingScaleID;
              ss.objStudentProgram[this.idx].postGradingScaleID = gradingScaleID;
            }
            ss.objStudentProgram[this.idx].gradingScaleID = ss.objStudentProgram[this.idx].postGradingScaleID;
            ss.objStudentProgram[this.idx].letterGrade = ss.objStudentProgram[this.idx].postGradingScaleID == '' || ss.objStudentProgram[this.idx].postGradingScaleID == null
              ? ss.letter_grade : this.getLetterGrade(ss.objStudentProgram[this.idx].postGradingScaleID);
            ss.objStudentProgram[this.idx].citizenshipCode = ss.objStudentProgram[this.idx].postCitizenshipCode != undefined ? ss.objStudentProgram[this.idx].postCitizenshipCode.toString() : "";
            ss.objStudentProgram[this.idx].workHabitCode = ss.objStudentProgram[this.idx].postWorkHabitCode != undefined ? ss.objStudentProgram[this.idx].postWorkHabitCode.toString() : "";
            ss.objStudentProgram[this.idx].receptiveSkills = ss.objStudentProgram[this.idx].postReceptiveSkills != undefined ? ss.objStudentProgram[this.idx].postReceptiveSkills.toString() : "";
            ss.objStudentProgram[this.idx].expressiveSkills = ss.objStudentProgram[this.idx].postExpressiveSkills != undefined ? ss.objStudentProgram[this.idx].postExpressiveSkills.toString() : "";

            if (ss.objStudentProgram[this.idx].letterGrade == '') {
              this.messageService.add({ sticky: true, severity: 'error', summary: 'Error', detail: 'You must select a valid letter grade for this student.' })
              this.isDirty = true;
              this.isPublishClicked = false;
              return;
            }



            // Not allow to post grades with out comments, bug#231306
            if (ss.objStudentProgram[this.idx].isCommentRequired == true || ss.objStudentProgram[this.idx].isValidationFailed == true) {
              this.isPublishClicked = false;
              this.isDirty = true;
              return;
            }
            if ((ss.objStudentProgram[this.idx].letterGrade || '') == '') {
              this.isPublishClicked = false;
              this.isDirty = true;
              return;
            }
            // Added the condition to avoid posting data to inactive students.
            if (ss.objStudentProgram[this.idx].editFlag)
              grades.push(ss.objStudentProgram[this.idx]);
          }

        }
        let counter: number = 0;
        let failureCounter: number = 0;
        console.log("PostGradesLog Start");
        console.log(grades);
        console.log("PostGradesLog End");
        this.http.post<PostSectionGradingPeriodGradesResponse>(this.baseUri + 'studentgrade/postgrades', grades).subscribe(data => {
          //this.getstudentprogam(this.http, this.baseUri);
          let response = data;

          this.DirtyGP = "";
          this.msgs1 = [];

          if (response == null || response == undefined) {
            this.messageService.add({ key: 'c', sticky: true, severity: 'error', summary: 'Error ', detail: 'Oops, Something went wrong. Please try again later.' });
          }
          else if (response.generalError != null || response.generalError != undefined) {
            this.errorMessage = response.generalError;
            this.msgs1 = [
              { severity: 'error', summary: 'Error', detail: response.generalError }
            ]

          }
          else {
            if (response.grades.grade.length === grades.length) {
              for (let gr of response.grades.grade) {
                if (gr.response_code === "200") {
                  counter = counter + 1;
                  this.studentsdata.filter(stu => stu.school_uid == gr.student_id)[0].currentState = 'state-success';
                  //this.studentsdata.filter(
                    //(stu) => stu.school_uid == gr.student_id
                  //)[0].currentState = studentWithErr.includes(gr.student_id) ? "state-pending" : "state-success";
                  this.studentsdata.filter(stu => stu.school_uid == gr.student_id)[0].objStudentProgram[this.SelectedGPIndex].status = 'success';
                }
                else {
                  failureCounter = failureCounter + 1;
                  this.studentsdata.filter(stu => stu.school_uid == gr.student_id)[0].currentState = 'state-error';
                  this.studentsdata.filter(stu => stu.school_uid == gr.student_id)[0].objStudentProgram[this.SelectedGPIndex].status = 'error';
                }
              }
              if (counter === grades.length) {
                this.isDirty = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Submitted Successfully at ' + formatDate(new Date(), 'MM/dd/yyyy hh:mm a', 'en-US') })
                this.publishedDate = new Date();
                this.msgs1 = [];
                this.msgs2 = [];
                this.msgs2 = [
                  { severity: 'info', summary: 'ALERT', detail: 'Last Published: ' + formatDate(new Date(), 'MM/dd/yyyy hh:mm a', 'en-US') + ' by ' + this.employeeName }
                ]

                //this.msgs1 = [
                //  { severity: 'success', summary: 'Success', detail: 'Submitted Successfully.' }
                //]
              }
              else if (failureCounter === grades.length) {
                this.messageService.add({ sticky: true, severity: 'error', summary: 'Error', detail: 'None of the grades are submitted' })

                //this.msgs1 = [
                //  { severity: 'error', summary: 'Error', detail: 'None of the grades are submitted.' }
                //]
              }
              else {
                this.messageService.add({ sticky: true, severity: 'warn', summary: 'Warning', detail: 'Partial Submitted Successfully at ' + formatDate(new Date(), 'dd/MM/yyyy hh:mm a', 'en-US') })

                //this.msgs1 = [
                //  { severity: 'success', summary: 'Success', detail: 'Partial Submitted Successfully.' }
                //]
              }
            }
            else {
              this.messageService.add({ sticky: true, severity: 'warn', summary: 'Warning', detail: 'Partial Submitted Successfully at ' + formatDate(new Date(), 'dd/MM/yyyy hh:mm a', 'en-US') })

              //this.msgs1 = [
              //  { severity: 'success', summary: 'Success', detail: 'Partial Submitted Successfully.' }
              //]
            }
          }
          this.getGradesCount();
          this.selectedStudents = [];

        }, error => {
          this.isPublishClicked = false;
          console.log("Oooops!");
        });

        //this.http.get('http://localhost:57150/grade', grades);

      }
      else {
        this.messageService.add({ sticky: true, severity: 'warn', summary: 'Warning', detail: 'No Students selected for grade submission.' })
      }

      this.isPublishClicked = false;
    }


    this.selectedWorkHabitOverride = null;
    this.selectedReceptiveSkillsOverride = null;
    this.selectedExpressiveSkillsOverride = null;
    this.selectedGradeOverride = null;
    this.selectedCoopOverride = null;
  }

  saveData(selectedStudents) {
    if (selectedStudents != null) {
      let grades: StudentProgram[] = [];
      let sectionId: number;
      let gradingPeriodId: string;

      //let http: HttpClient;
      for (let ss of selectedStudents) {
        // var idx = ss.objStudentProgram.length - 1;
        ss.objStudentProgram[this.idx].comment1 = ss.objStudentProgram[this.idx].postComment1 != undefined ? ss.objStudentProgram[this.idx].postComment1.toString() : null;
        ss.objStudentProgram[this.idx].comment2 = ss.objStudentProgram[this.idx].postComment2 != undefined ? ss.objStudentProgram[this.idx].postComment2.toString() : null;
        ss.objStudentProgram[this.idx].comment3 = ss.objStudentProgram[this.idx].postComment3 != undefined ? ss.objStudentProgram[this.idx].postComment3.toString() : null;
        ss.objStudentProgram[this.idx].gradingScaleID = ss.objStudentProgram[this.idx].postGradingScaleID;
        ss.objStudentProgram[this.idx].letterGrade = this.getLetterGradebyCode(ss.objStudentProgram[this.idx].postGradingScaleID);
        ss.objStudentProgram[this.idx].citizenshipCode = ss.objStudentProgram[this.idx].postCitizenshipCode != undefined ? ss.objStudentProgram[this.idx].postCitizenshipCode.toString() : "";
        ss.objStudentProgram[this.idx].workHabitCode = ss.objStudentProgram[this.idx].postWorkHabitCode != undefined ? ss.objStudentProgram[this.idx].postWorkHabitCode.toString() : "";
        sectionId = ss.objStudentProgram[this.idx].sectionID;
        gradingPeriodId = ss.objStudentProgram[this.idx].schoolTermGradingPeriodID;
        grades.push(ss.objStudentProgram[this.idx]);
      }

      let counter: number = 0;
      let failureCounter: number = 0;

      this.http.post<PostSectionGradingPeriodGradesResponse>(this.baseUri + 'studentgrade/savegrades', grades).subscribe(data => {
        let response = data;
        if (response.generalError != null || response.generalError != undefined) {
          this.errorMessage = response.generalError;
          this.msgs1 = [
            { severity: 'error', summary: 'Error', detail: response.generalError }
          ]
        }
        else {
          if (response.grades.grade.length === grades.length) {
            for (let gr of response.grades.grade) {
              if (gr.response_code === "200") {
                counter = counter + 1;
                this.studentsdata.filter(stu => stu.school_uid == gr.student_id)[0].currentState = 'state-success';
              }
              else {
                failureCounter = failureCounter + 1;
                this.studentsdata.filter(stu => stu.school_uid == gr.student_id)[0].currentState = 'state-error';
              }
            }
            if (counter === grades.length) {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Saved Successfully' })
            }
            else if (failureCounter === grades.length) {
              this.messageService.add({ sticky: true, severity: 'error', summary: 'Error', detail: 'None of the grades are Saved' })
            }
            else {
              this.messageService.add({ sticky: true, severity: 'warn', summary: 'Warning', detail: 'Partial Saved Successfully' })
            }
          }
          else {
            this.messageService.add({ sticky: true, severity: 'warn', summary: 'Warning', detail: 'Partial Saved Successfully' })
          }
        }
      }, error => {
        console.log("Oooops!");
      });
    }
    else {
      //this.errorMessage = "No Students selected for grade submission.";
      this.messageService.add({ severity: 'warn', summary: 'NOTICE', detail: 'No Students selected for grade Saving.' })
    }
  }

  redirectHistory() {
    //location.href = '/history?realm=' + this.realm + '&realm_id=' + this.realm_id + '&app_id=' + this.app_id + '&is_ssl=' + this.is_ssl;
    //this.isSecondarySection = false;
    this.isHistorySection = true;

    this.statusLogdata = null;
    this.loading = true;
    this.getstatusLog(this.httpClient, this.baseUri);

    // this.msgs2 = this.msgs1;

    //this.msgs1 = [];
  }

  redirectHome() {
    //this.isSecondarySection = true;
    this.isHistorySection = false;
    //this.msgs1 = this.msgs2;
    if (this.publishedDate != null) {
      if (this.LastGradeSubmitted.length > 1) {
        this.msgs2 = [
          { severity: 'info', summary: 'ALERT', detail: 'Last Published: ' + new Date(this.publishedDate).toLocaleString() + ' by ' + this.employeeName + ' from ' + this.LastGradeSubmitted }
        ]
      }
      else {
        this.msgs2 = [
          { severity: 'info', summary: 'ALERT', detail: 'Last Published: ' + new Date(this.publishedDate).toLocaleString() + ' by ' + this.employeeName }
        ]
      }
    }
  }

  OnChangeHistoryGradingPeriod() {
    // For All Grading Periods selection -- dummy value 0000
    if (this.historyselectedGP == '0000') {
      this.statusLogdata = this.parent_StatusLogdata;
    }
    else {
      this.statusLogdata = this.parent_StatusLogdata.filter(c => c.schoolTermGradingPeriodId == this.historyselectedGP);
    }
  }

  CreatePdfNew(preview = false) {
    this.isPdfGenerating = true;

    // Add toast notification when PDF generation starts
    this.messageService.add({
      severity: 'info',
      summary: 'Generating PDF',
      detail: 'Your PDF is being prepared for download. Please wait...',
      life: 5000
    });
    
    let gpName = this.gradingperiodobj.filter(gp => gp.schoolTermGradingPeriodId == this.selectedGP)[0].gradingPeriod;
    let sgd = Object.keys(this.gradeCounts)[0] + ": " + Object.values(this.gradeCounts)[0] || 0;

    let sgdCount = Object.keys(this.gradeCounts).length;

    for (var _i = 1; _i < sgdCount; _i++) {
      if (Object.values(this.gradeCounts)[_i] != undefined) {
        sgd = sgd + "-" + Object.keys(this.gradeCounts)[_i] + ": " + Object.values(this.gradeCounts)[_i] || 0;
      }
    }

    // Added to retrieve the Employee Name for the grading period
    this.instructorName = this.studentsdata[0].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].employeeName;
    this.user_id = this.studentsdata[0].objStudentProgram.filter(s => s.schoolTermGradingPeriodID == this.selectedGP)[0].employeeID;

    var encodedSectionname = this.codec.encodeValue(this.sectionname);

    // Reset the flag after a reasonable timeout (since we can't detect actual completion)
    setTimeout(() => {
      this.isPdfGenerating = false;
    }, 5000); // 5 seconds should be enough for most PDF generations

    location.href = "/SGPBHome/generatepdf?sectionId=" + this.sectionid + "&&StaffId=" + this.user_id + "&&gpName=" + gpName + "&&sectionName=" + encodedSectionname + "&&instructorName=" + this.instructorName + "&&gradeDistribution=" + sgd + "&&preview=" + preview;
  }


  createPdf() {
    //this.getpdf(this.httpClient, this.baseUri);

    this.data = [];
    const doc = new jsPDF();

    let gpName = this.gradingperiodobj.filter(gp => gp.schoolTermGradingPeriodId == this.selectedGP)[0].gradingPeriod;

    doc.setFontSize(10);
    doc.text(this.sectionname + '  Grading Period:' + gpName, 11, 6);

    let sgd = Object.keys(this.gradeCounts)[0] + ": " + Object.values(this.gradeCounts)[0] || 0;

    if (Object.values(this.gradeCounts)[1] != undefined) {
      sgd = sgd + "-" + Object.keys(this.gradeCounts)[1] + ": " + Object.values(this.gradeCounts)[1] || 0;
    }

    if (Object.values(this.gradeCounts)[2] != undefined) {
      sgd = sgd + "-" + Object.keys(this.gradeCounts)[2] + ": " + Object.values(this.gradeCounts)[2] || 0;
    }

    if (Object.values(this.gradeCounts)[3] != undefined) {
      sgd = sgd + "-" + Object.keys(this.gradeCounts)[3] + ": " + Object.values(this.gradeCounts)[3] || 0;
    }

    if (Object.values(this.gradeCounts)[4] != undefined) {
      sgd = sgd + "-" + Object.keys(this.gradeCounts)[4] + ": " + Object.values(this.gradeCounts)[4] || 0;
    }

    //doc.setFontSize(9);    
    //doc.text('Student Grade Distribution: ' + sgd, 11, 9);

    doc.setFontSize(9);
    doc.text('Instructor:' + this.instructorName + "               Student Grade Distribution: " + sgd, 11, 12);

    doc.setFontSize(5);
    doc.setTextColor(100);

    location.href = "http://localhost:57122/studentgrade/generatepdf?sectionId=" + this.sectionid + "&&StaffId=" + this.user_id + "&&gpName=" + gpName + "&&sectionName=" + this.sectionname + "&&instructorName=" + this.instructorName + "&&gradeDistribution=" + sgd;

    for (let student of this.studentsdata) {
      student.index = student.objStudentProgram.length - 1;
      const studentProgram = this.studentUtils.getStudentProgramAtIndex(student, this.SelectedGPIndex);
      if (!studentProgram) return;
    
      let comment1 = ''; let comment2 = ''; let comment3 = ''; let finalComment = '';

      if (studentProgram != null && studentProgram != undefined) {

        if (studentProgram.comment1 != null && studentProgram.comment1 != undefined && studentProgram.comment1 != '') {
          comment1 = studentProgram.comment1 + ' - ' + this.getCommentName(studentProgram.comment1);

          finalComment = comment1;
        }

        if (studentProgram.comment2 != null && studentProgram.comment2 != undefined && studentProgram.comment2 != '') {
          comment2 = studentProgram.comment2 + ' - ' + this.getCommentName(studentProgram.comment2);

          if (finalComment != '') {
            finalComment = finalComment + ', ' + comment2;
          }
          else {
            finalComment = comment2;
          }
        }

        if (studentProgram.comment3 != null && studentProgram.comment3 != undefined && studentProgram.comment3 != '') {
          comment3 = studentProgram.comment3 + ' - ' + this.getCommentName(studentProgram.comment3);

          if (finalComment != '') {
            finalComment = finalComment + ', ' + comment3;
          }
          else {
            finalComment = comment3;
          }
        }
        if (student.studentLastName != null && student.studentLastName != "") {
          student.studentLastName = student.studentLastName.toUpperCase();
        }
        if (student.studentFirstName != null && student.studentFirstName != "") {
          student.studentFirstName = student.studentFirstName.toUpperCase();
        }
        if (student.studentMiddleName != null && student.studentMiddleName != "") {
          student.studentMiddleName = student.studentMiddleName.toUpperCase();
        }
        this.data.push([student.studentLastName + ', ' + student.studentFirstName + ' ' + student.studentMiddleName, student.letter_grade,
        studentProgram.letterGrade || this.getLetterGrade(studentProgram.postGradingScaleID) || '',
          studentProgram.workHabitCode || studentProgram.postWorkHabitCode || '',
          studentProgram.receptiveSkills || studentProgram.postReceptiveSkills || '',
          studentProgram.expressiveSkills || studentProgram.postExpressiveSkills || '',
        studentProgram.citizenshipCode || studentProgram.postCitizenshipCode || '',
          finalComment]);

      }

      //if (finalComment == '') {
      //  finalComment = 'N/A, N/A, N/A';
      //}
    }

    let height = doc.internal.pageSize.getHeight();
    doc.setFontSize(8);
    doc.text(new Date().toLocaleString(), 11, height - 5);


    (doc as any).autoTable({
      head: this.head,
      body: this.data,
      theme: 'striped',
      didDrawCell: data => {
        //console.log(data.column.index)
      }
    })

    //doc.setFontSize(10);
    //doc.text("© 2017-2020 Company Name", 11, 8);

    // below line for Open PDF document in new tab
    doc.output('dataurlnewwindow')

    // below line for Download PDF document  
    doc.save('StudentProgram.pdf');
  }

  getCommentName(comment) {
    if (comment != null && comment != undefined) {
      let commObj = this.gradescomments.filter(c => c.comment_code == comment)[0];

      if (commObj != undefined) { return commObj.comment; } else { return "N/A"; }
    }
    else { return "N/A"; }
  }

  getCommentlabel(comment) {
    if (comment != null && comment != undefined) {
      let commObj = this.gradescomments.filter(c => c.comment_code == comment)[0];

      if (commObj != undefined) { return commObj.label; } else { return "N/A"; }
    }
    else { return "N/A"; }
  }

  // To do, refactor to be more reusable
  getLetterGradebyCode(code) {
    if (code != null && code != undefined) {
      let commObj = this.gradingscales.filter(c => c.gradingScaleID == code)[0];
      if (commObj != undefined) { return commObj.letterGrade; } else { return "N/A"; }
    }
    else { return "N/A"; }
  }

  getLetterGrade(code) {
    if (code != null && code != undefined) {
      let commObj = this.gradingscales.filter(c => c.gradingScaleID == code)[0];
      if (commObj != undefined) { return commObj.letterGrade; } else { return ""; }
    }
    else { return ""; }
  }

  getCommentData(comment) {
    if (comment != null && comment != undefined) {
      let commObj = this.gradescomments.filter(c => c.comment_code == comment)[0];

      if (commObj != undefined) { return commObj.comment; } else { return ""; }
    }
    else { return ""; }
  }

  getWorkbyCode(code) {
    if (code != null && code != undefined) {
      let commObj = this.workhabitcodes.filter(c => c.workHabitCode == code)[0];
      if (commObj != undefined) { return commObj.workHabitCode; } else { return "N/A"; }
    }
    else { return "N/A"; }
  }

  getCitizenbyCode(code) {
    if (code != null && code != undefined) {
      let commObj = this.citizenshipcodes.filter(c => c.citizenshipCode == code)[0];
      if (commObj != undefined) { return commObj.description; } else { return "N/A"; }
    }
    else { return "N/A"; }
  }

  showCommentDialog() {
    this.commentDialog = true;
  }

  getpdf() {
    if (this.studentsdata != null) {
      location.href = "http://localhost:57122/studentgrade/generatepdf?data=" + this.studentsdata;
    }
    else {
      location.href = "http://localhost:57122/studentgrade/generatepdf?data=" + null;
    }


    //http.get(baseUrl + 'studentgrade/generatepdf').subscribe(result:any => {

    //  let blob: any = new Blob([result.blob()], { type: 'text/json; charset=utf-8' });


    //}, error => this.errorService(error));
  }

  getstatusLog(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.dataSourceService.getData<ResponseStatusLogDetail[]>(
      'studentgrade/getstatuslog?SectionId=' + this.sectionid,
      baseUrl
    ).subscribe(result => {
      this.statusLogdata = result;
      this.parent_StatusLogdata = result;
      this.statusLogdata = this.parent_StatusLogdata.filter(c => c.schoolTermGradingPeriodId == this.historyselectedGP);
      this.loading = false;
    }, error => this.errorService(error));
  }

  getstatusLogInfoDetails(http: HttpClient, @Inject('BASE_URL') baseUrl: string, processId) {
    this.dataSourceService.getData<ResponseStatusLogInfoDetail[]>(
      'studentgrade/getstatuslogdetails?ProcessId=' + processId,
      baseUrl
    ).subscribe(result => {
      this.statusLogdata.forEach(data => {
        if (data.processId == processId) {
          data.lstLogStudentDetails = result;
          data.lstLogStudentDetails.forEach(detail => {
            let studentInfo = this.studentsdata.filter(c => c.school_uid == detail.studentId)[0];
            if (studentInfo.studentFirstName != null && studentInfo.studentFirstName != "") {
              studentInfo.studentFirstName = studentInfo.studentFirstName.toUpperCase();
            }
            if (studentInfo.studentLastName != null && studentInfo.studentLastName != "") {
              studentInfo.studentLastName = studentInfo.studentLastName.toUpperCase();
            }
            if (studentInfo.studentMiddleName != null && studentInfo.studentMiddleName != "") {
              studentInfo.studentMiddleName = studentInfo.studentMiddleName.toUpperCase();
            }
            detail.studentName = studentInfo.studentFirstName + " " + studentInfo.studentLastName + " " + studentInfo.studentMiddleName + " (" + studentInfo.school_uid + ") ";
          });
        }
      });
    }, error => this.errorService(error));
  }

  onHistoryRowExpand(data) {

    let processId = data.data.processId;
    this.getstatusLogInfoDetails(this.httpClient, this.baseUri, processId);

    if (Object.keys(this.expandedRowsHistory).length === this.temDataLength) {
      this.isExpanded = true;
    }
  }

}

